export default () => ({
  plotOptions: {
    series: {
      stickyTracking: false,
    },
  },
});
